import { Stack, Text } from '@chakra-ui/react';
import { useTranslations } from 'use-intl';

import { formatNumberCurrency, formatNumberPercentage } from '@blockpulse3/helpers';

import { useSPVForm } from '../../../provider';

type Props = unknown;

/**
 * SummaryCompanyInfos.
 * Summary company infos for the SPV funnel.
 *
 * @returns {JSX.Element}
 */
export function SummaryCompanyInfos(): JSX.Element {
  const i18nSummaryCompanyInfos = useTranslations('SPVSummaryCompanyInfos');

  const { companyDraftContent } = useSPVForm();
  const { address } = companyDraftContent;

  return (
    <Stack spacing="4">
      <Text fontSize="xl" fontWeight="bold">
        {i18nSummaryCompanyInfos('Title')}
      </Text>
      <Stack bg="gray.50" borderRadius="md" p="3" spacing="1">
        <Text>
          <Text as="span" fontWeight="bold" mr="2">
            {i18nSummaryCompanyInfos('Name')} :
          </Text>
          {companyDraftContent.name}
        </Text>
        <Text>
          <Text as="span" fontWeight="bold" mr="2">
            {i18nSummaryCompanyInfos('Address')} :
          </Text>
          {`${address.line}, ${address.postalCode} ${address.city}, ${address.countryData.label}`}
        </Text>
        <Text>
          <Text as="span" fontWeight="bold" mr="2">
            {i18nSummaryCompanyInfos('SocialForm')} :
          </Text>
          {/* TODO: fix this after spv workflow refactoring */}
          {companyDraftContent.corporateForm || 'Société par actions simplifiée à capital variable'}
        </Text>
        <Text>
          <Text as="span" fontWeight="bold" mr="2">
            {i18nSummaryCompanyInfos('SocialCapital')} :
          </Text>
          {formatNumberCurrency(companyDraftContent.initialShareholder.capitalDeposit)}
        </Text>
        <Text>
          <Text as="span" fontWeight="bold" mr="2">
            {i18nSummaryCompanyInfos('CarriedInterest')} :
          </Text>
          {formatNumberPercentage(companyDraftContent.carriedInterest)}
        </Text>
        <Text>
          <Text as="span" fontWeight="bold" mr="2">
            {i18nSummaryCompanyInfos('DealName')} :
          </Text>
          {companyDraftContent.target.name}
        </Text>
      </Stack>
    </Stack>
  );
}

export type SummaryCompanyInfosProps = Props;
